enum PERMITER_SEARCH_MODE {
  SEARCH_ENABLED = 'search-enabled',
  SEARCH_DISABLED = 'search-disabled',
}

export default PERMITER_SEARCH_MODE
